// extracted by mini-css-extract-plugin
export default {"background-blue":"ContactUs_background-blue__gYN93","close-btn":"ContactUs_close-btn__Towzn","update-email-btn":"ContactUs_update-email-btn__1N-Sh"};